import { Modal, Tabs } from 'antd';
import React, { FC, useEffect } from 'react';
import { useLazyGetSettingsQuery } from 'app/services/edpApiV1/admins';
import { TItemsTab } from 'shared/types/types';
import { RolesUser } from 'shared/enums';
import TTLPasswordSettings from './ttlPasswordSettings/TTLPasswordSettings';
import OrgstructureSettings from './orgStructureSettings/OrgstructureSettings';
import style from './index.module.scss';

type TSecurityModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: (val: boolean) => void;
};

const SecurityModal: FC<TSecurityModalProps> = ({ isModalOpen, setIsModalOpen }) => {
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [getSettings, { data }] = useLazyGetSettingsQuery();

  useEffect(() => {
    getSettings();
  }, [isModalOpen]);

  const itemsTab: TItemsTab = [
    {
      label: 'Настройки безопасности',
      key: 'settings',
      children: <TTLPasswordSettings settings={data} />,
      role: [RolesUser.HRDirector],
    },
    {
      label: 'Настройки оргструктуры',
      key: 'orgstructure',
      children: <OrgstructureSettings />,
      role: [RolesUser.HRDirector],
    },
  ];

  return (
    <Modal
      title="Настройки"
      footer={false}
      className="security-modal"
      onCancel={handleCancel}
      open={isModalOpen}
      height={700}
      destroyOnClose
    >
      <Tabs destroyInactiveTabPane items={itemsTab}></Tabs>
    </Modal>
  );
};

export default SecurityModal;
